import clsx from 'clsx';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CommonPopper from '../../../../components/common-popper/CommonPopper';
import Td from '../../../../components/common-table/components/Td';
import Tr from '../../../../components/common-table/components/Tr';
import { ICONS } from '../../../../icons';
import Icon from '../../../../icons/Icon';
import dayjs from '../../../../utils/dateUtils';
import UserTablePopper from './UserTablePopper';

import scss from './UserTable.module.scss';

const UserTableItem = ({
  user,
  rowRank,
  userRoles = [],
  onOpenDeleteModal,
  onOpenEnableModal,
  onChangePasswordModal,
}) => {
  const { id, name, username, createdOn, roleName, enabled } = user;
  const {
    t,
    i18n: { language },
  } = useTranslation('userManagement');

  const roleLabel = useMemo(
    () => userRoles.find((role) => role.value === roleName).label || roleName,
    [userRoles, roleName],
  );

  const formattedCreatedOn = useMemo(() => {
    return dayjs(createdOn, 'DD.MM.YYYY h:mm:ss').locale(language).format('MMM D[,] YYYY [at] HH:mm');
  }, [createdOn, language]);

  const handleOpenEnableUserModal = useCallback(() => {
    onOpenEnableModal({ id, name, enabled });
  }, [onOpenEnableModal, id, name, enabled]);

  const handleOpenDeleteUserModal = useCallback(() => {
    onOpenDeleteModal({ id, name });
  }, [id, name, onOpenDeleteModal]);

  const handleOpenChangePasswordModal = useCallback(() => {
    onChangePasswordModal({ id });
  }, [onChangePasswordModal, id]);

  return (
    <Tr extraClasses={clsx(!enabled && scss.rowBlocked)} disableHover={!enabled}>
      <Td extraClasses={scss.cellId}>{rowRank}</Td>
      <Td extraClasses={clsx(scss.cellName, scss.cellLeft)}>{name}</Td>
      <Td extraClasses={scss.cellLeft}>{username}</Td>
      <Td extraClasses={scss.cellLeft}>{enabled ? t('active') : t('inactive')}</Td>
      <Td extraClasses={scss.cellLeft}>{formattedCreatedOn}</Td>
      <Td extraClasses={scss.cellLeft}>{roleLabel}</Td>
      <Td extraClasses={clsx('cell-btn', scss.cellLeft)}>
        <CommonPopper
          isShowCaret={false}
          disablePortal={false}
          placement='left-start'
          component={() => (
            <UserTablePopper
              user={user}
              onBlockUserModalOpen={handleOpenEnableUserModal}
              onDeleteUserModalOpen={handleOpenDeleteUserModal}
              onChangePasswordModalOpen={handleOpenChangePasswordModal}
            />
          )}>
          <Icon icon={ICONS.TwoDots} disableCommonColors disableCommonStyles className={scss.dotsIcon} />
        </CommonPopper>
      </Td>
    </Tr>
  );
};

export default UserTableItem;
